import {
  Avatar,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  useColorModeValue,
} from '@chakra-ui/react';
import { useState } from 'react';
import { LuCircleUserRound, LuSettings2 } from 'react-icons/lu';

import { useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import FiliaisModal from './FiliaisModal';
import InvoicesModal from './InvoicesModal';

export function Profile() {
  const [showFaturas, setShowFaturas] = useState(false);
  const [showFiliais, setShowFiliais] = useState(false);
  const { user, signOut } = useAuth();
  const history = useHistory();

  const bg = useColorModeValue('white', 'gray.800');

  return (
    <Flex align="center">
      <Menu isLazy>
        <MenuButton>
          <Avatar size="sm" name={user.name} src={user?.avatarUrl} />
        </MenuButton>
        <MenuList>
          <MenuGroup title={user.name}>
            <MenuItem
              icon={<LuCircleUserRound size="22" />}
              onClick={() => history.push(`/perfil`)}
            >
              Perfil
            </MenuItem>
            {/* <MenuItem
              icon={<LuReceiptText size="22" />}
              onClick={() => setShowFaturas(prev => !prev)}
            >
              Faturas do Sistema
            </MenuItem>
            <MenuItem
              icon={<Building2 size="22" />}
              onClick={() => setShowFiliais(prev => !prev)}
            >
              Trocar Filial
            </MenuItem> */}
            <MenuItem icon={<LuSettings2 size="22" />}>
              Configurações da conta
            </MenuItem>
          </MenuGroup>

          <MenuDivider />

          <MenuItem
            _hover={{
              bg,
            }}
          >
            <Button
              colorScheme="blue"
              variant="outline"
              size="md"
              fontSize="sm"
              onClick={signOut}
              isFullWidth
            >
              Logout
            </Button>
          </MenuItem>
        </MenuList>
      </Menu>

      <InvoicesModal
        isOpen={showFaturas}
        onClose={() => setShowFaturas(false)}
      />

      <FiliaisModal aberto={showFiliais} fechar={() => setShowFiliais(false)} />
    </Flex>
  );
}
